import Icons from "../../assets/icons/index.js";
import {
  Btn,
  InputField,
  FormHeading,
  AuthLayout,
} from "../../components/index";
import { fontSizes } from "../../constants/constants.js";
import ResetPasswordFunction from "./index.function.js";
export default function LoginScree() {
  const {
    onSubmitProfile,
    errors,
    getValues,
    setValue,
    handleSubmit,
    register,
    loadingToapi,
    TextWeight,
  } = ResetPasswordFunction();
  return (
    <AuthLayout isBackBnt={true} isPath={"/OtpVerification"}>
      <FormHeading
        title="Reset"
        highlightText={"Password"}
        description={
          "New password must be different from your previous used password"
        }
      />
      <form className="px-2 " onSubmit={handleSubmit(onSubmitProfile)}>
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="password"
            name="password"
            placeholder="New Password"
            // {...register("password", { required: 'New Password is required' })}
            {...register("password", {
              required: "Password is required",
              pattern: {
                value:
                  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,16}$/,
                message:
                  "Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.",
              },
            })}
            onChange={(value) => setValue("password", value)}
            isPassword={true}
            icon={Icons.lockIcons}
            iconPasswordVisible={Icons.showPasswordIcon}
            iconPasswordHidden={Icons.hidePasswordIcon}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
          />
          {errors.password && (
            <span style={{ color: "red" }}>{errors.password.message}</span>
          )}
        </div>
        <div className="relative mt-2.5 2xl:mt-5 ">
          <InputField
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            {...register("confirmPassword", {
              required: "Confirm Password is required",
              validate: (value) =>
                value === getValues("password") || "Passwords do not match",
            })}
            onChange={(value) => setValue("confirmPassword", value)}
            isPassword={true}
            icon={Icons.lockIcons}
            iconPasswordVisible={Icons.showPasswordIcon}
            iconPasswordHidden={Icons.hidePasswordIcon}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
          />
          {errors.confirmPassword && (
            <span style={{ color: "red" }}>
              {errors.confirmPassword.message}
            </span>
          )}
        </div>
        <Btn
          type={"submit"}
          isDisabled={loadingToapi}
          loading={loadingToapi}
          isprimary={false}
          weight={TextWeight.Raleway_SemiBold}
          textSize={fontSizes.h18}
          text={"Update"}
          color="text-white"
          hover={"hover:text-primary hover:bg-white hover:border-primary"}
          bgColor={"bg-primary border-transparent"}
          className={"mt-4 mx-auto"}
        />
      </form>
    </AuthLayout>
  );
}
